<script lang="typescript">
    import LensDetail from "./LensDetail.svelte";
    import type { LogoImage, State } from "../types";
    import { variantImages, lensOption } from "../appData.js";
    import { logoImages } from "../appData.js";
    import { state } from "../stores.js";
    import { isChildrenLens, getSecondaryVariant } from "../utils.js";

    let images = variantImages.transitionsXtractive;
    if (isChildrenLens($state)) {
        images = variantImages.adaptiveBoy;
    }

    const isPolarized = (state: State): boolean => {
        let secondaryVariant = getSecondaryVariant(state);
        return (
            secondaryVariant !== null &&
            secondaryVariant.optionType === lensOption.TRANSITIONS_XTRA_POLARIZED
        );
    };

    const getLogo = (state: State): LogoImage => {
        let logo = logoImages.xtractive;
        if (isPolarized(state)) {
            logo = logoImages.xtractivePolarized;
        }
        return logo;
    };

    let logo: LogoImage;
    $: logo = getLogo($state);
</script>

<LensDetail {logo} {images}>
    <div>
        <ul>
            {#if isPolarized($state)}
                <li>Up to 90% polarization</li>
            {/if}
            <li>Lenses that change colour from indoor to outdoor, even in the car</li>
            <li>
                All the benefits of Transitions with improved performance in the car and in hotter
                temperatures
            </li>
            <li>Lenses that protect from bright sunlight whilst in the car</li>
            <li>Clear with a hint of protective tint whilst indoors</li>
            <li>Designed to wear every day</li>
            <li>Filtering blue - violet light indoor and outdoors</li>
        </ul>
    </div>
    <div>
        <h2>Who is it suitable for?</h2>
        <ul>
            {#if isChildrenLens($state)}
                <li>Someone that spends time indoors and outdoors, including students</li>
            {:else}
                <li>Adults</li>
                <li>Someone that spends time indoors and outdoors and drives</li>
                <li>Occupations may include: students, builders, gardeners, postperson, drivers</li>
            {/if}
        </ul>
    </div>
</LensDetail>
